import React from "react";
import { DirectionalHint, IDropdownOption, TooltipHost } from "@nuorder/components";
import { Field, VersatileSelectorProps } from "react-querybuilder";
import { styles } from "./custom-field-selector.styles";
import { CustomFieldDropdown } from "./custom-field-dropdown";

const tooltipProps = {
    calloutProps: {
        styles: styles.callout,
    },
};

export const CustomFieldSelector: React.FC<VersatileSelectorProps> = ({
    className,
    handleOnChange,
    value,
    options = [],
    disabled,
    fieldData,
    context,
}) => {
    const usedRuleValues = React.useMemo(
        () => context.query.rules.map((rule) => (rule?.value?.parent ? rule.value.parent : rule.field)),
        [context.query.rules]
    );
    const dropdownOptions: IDropdownOption[] = React.useMemo(
        () =>
            (options as Array<Field>).map(({ name, label, ...data }) => ({
                key: name,
                text: label,
                selected: value?.includes(name),
                data,
                disabled: data?.isUnique && usedRuleValues.includes(name),
            })),
        [options, usedRuleValues, value]
    );

    const tooltipContent = React.useMemo(() => {
        const tooltipContent = [];

        dropdownOptions.forEach((dropdownOption) => {
            if (dropdownOption.selected) {
                tooltipContent.push(dropdownOption.text);
            }
        });

        return tooltipContent.join(", ");
    }, [dropdownOptions]);

    const hideTooltip = !(Array.isArray(value) && value.length > 0);

    return (
        <TooltipHost
            content={<span style={styles.toolTipContent}>{tooltipContent}</span>}
            directionalHint={DirectionalHint.bottomCenter}
            hidden={hideTooltip}
            tooltipProps={tooltipProps}
        >
            <CustomFieldDropdown
                options={dropdownOptions}
                value={value}
                disabled={disabled}
                handleOnChange={handleOnChange}
                className={className}
                fieldData={fieldData}
            />
        </TooltipHost>
    );
};
